import { gql } from '@yi/core';
import { i18n_articles } from '@yi/i18n/phrases/i18n_articles';
import { i18n_breathwork } from '@yi/i18n/phrases/i18n_breathwork';
import { i18n_classes } from '@yi/i18n/phrases/i18n_classes';
import { i18n_meditations } from '@yi/i18n/phrases/i18n_meditations';

import { Locale } from '~/common';
import { CardType } from '~/types';

export type PracticeType = gql.typesClient.PracticeType;
const { PRANAYAMA } = gql.typesClient.PracticeType;

export const getMyLibraryContentType = ({
  cardType,
  practiceType,
  locale,
}: {
  cardType: CardType;
  practiceType?: PracticeType;
  locale: Locale;
}) => {
  if (!cardType) return null;
  const cardTypePhrases = {
    article: i18n_articles(locale),
    class: i18n_classes(locale),
    meditation: i18n_meditations(locale),
    pranayama: i18n_breathwork(locale),
  };
  const contentType = practiceType === PRANAYAMA ? 'pranayama' : cardType;
  return cardTypePhrases[contentType];
};
